/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Contact_SupportInputs */

const en_options_api_keys_contact_support = /** @type {(inputs: Options_Api_Keys_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please contact support for more information.`)
};

const fr_options_api_keys_contact_support = /** @type {(inputs: Options_Api_Keys_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez contacter le support pour plus d'informations.`)
};

const de_options_api_keys_contact_support = /** @type {(inputs: Options_Api_Keys_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für weitere Informationen wenden Sie sich bitte an den Support.`)
};

const it_options_api_keys_contact_support = /** @type {(inputs: Options_Api_Keys_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per ulteriori informazioni, contattare l'assistenza.`)
};

const ru_options_api_keys_contact_support = /** @type {(inputs: Options_Api_Keys_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для получения дополнительной информации обратитесь в службу поддержки.`)
};

const es_options_api_keys_contact_support = /** @type {(inputs: Options_Api_Keys_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comuníquese con el soporte para obtener más información.`)
};

const zh_cn2_options_api_keys_contact_support = /** @type {(inputs: Options_Api_Keys_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请联系客服获取更多信息。`)
};

const ja_options_api_keys_contact_support = /** @type {(inputs: Options_Api_Keys_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細についてはサポートにお問い合わせください。`)
};

const hi_options_api_keys_contact_support = /** @type {(inputs: Options_Api_Keys_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिक जानकारी के लिए कृपया सहायता टीम से संपर्क करें।`)
};

const pt_pt2_options_api_keys_contact_support = /** @type {(inputs: Options_Api_Keys_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre em contato com o suporte para obter mais informações.`)
};

/**
* | output |
* | --- |
* | "Please contact support for more information." |
*
* @param {Options_Api_Keys_Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_contact_support = /** @type {((inputs?: Options_Api_Keys_Contact_SupportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Contact_SupportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_contact_support(inputs)
	if (locale === "de") return de_options_api_keys_contact_support(inputs)
	if (locale === "it") return it_options_api_keys_contact_support(inputs)
	if (locale === "ru") return ru_options_api_keys_contact_support(inputs)
	if (locale === "es") return es_options_api_keys_contact_support(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_contact_support(inputs)
	if (locale === "ja") return ja_options_api_keys_contact_support(inputs)
	if (locale === "hi") return hi_options_api_keys_contact_support(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_contact_support(inputs)
	return en_options_api_keys_contact_support(inputs)
});